export default {
      id: "filter-usage",
      viewBox: "0 0 23 24",
      url: __webpack_public_path__ + "img/icons.c3436384.svg#filter",
      toString: function () {
        return this.url;
      }
    }